//加入单位步骤信息
export const SETCOMPANYSTEP = 'SETCOMPANYSTEP';

//公共数据
export const SETCOMMONDATA = 'SETCOMMONDATA';

//获取待处理数
export const SETCOUNTWAITTOHEADER = 'SETCOUNTWAITTOHEADER';

//更新单位人员列表
export const SETCOMPANYUSERLIST = 'SETCOMPANYUSERLIST';

//更新地区备选项
export const SETADDRESSLIST = 'SETADDRESSLIST';


// WEBPACK FOOTER //
// ./src/store/mutationTypes.js